import React from 'react';
import { LogIn, X } from 'lucide-react';

type Props = {
  open: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
};

/** Модалка «войдите, чтобы продолжить» — для гостей перед записью и т.п. */
export function AuthPromptModal({
  open,
  title = 'Нужен вход',
  message = 'Чтобы записаться на событие, войдите в аккаунт по номеру телефона.',
  confirmLabel = 'Войти',
  onConfirm,
  onClose,
}: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-end sm:items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.55)' }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="auth-prompt-title"
    >
      <div
        className="w-full max-w-sm rounded-3xl p-5"
        style={{ background: '#141414', border: '1px solid rgba(255,255,255,0.12)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-3">
          <h3
            id="auth-prompt-title"
            className="text-lg font-bold text-white"
            style={{ fontFamily: 'Unbounded, sans-serif', letterSpacing: '-0.02em' }}
          >
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-full shrink-0"
            style={{ color: 'rgba(255,255,255,0.4)' }}
            aria-label="Закрыть"
          >
            <X size={18} />
          </button>
        </div>
        <p
          className="text-sm leading-relaxed mb-5"
          style={{ color: 'rgba(255,255,255,0.55)', fontFamily: 'Manrope, sans-serif' }}
        >
          {message}
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={onConfirm}
            className="w-full py-3.5 rounded-2xl font-semibold text-sm tracking-[0.1em] uppercase inline-flex items-center justify-center gap-2 active:scale-[0.99]"
            style={{ background: '#fff', color: '#0a0a0a', fontFamily: 'Manrope, sans-serif' }}
          >
            <LogIn size={16} />
            {confirmLabel}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 rounded-2xl text-sm font-medium"
            style={{ color: 'rgba(255,255,255,0.5)', fontFamily: 'Manrope, sans-serif' }}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
}
